
<template>
  <div
    class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
    id="page-login"
  >

    <vs-prompt
      title="Forgot Your Password?"
      @cancel="val = ''"
      @accept="validateEmail"
      :active.sync="showForgotPassword"
    >
      <div class="con-exemple-prompt">
        <span>Enter Your Email Address</span>
        <vs-input
          v-validate="'required|min:3'"
          placeholder="enter your email here..."
          vs-placeholder="enter your email here..."
          v-model="emailRecovery"
          class="mt-3 w-full"
        />
      </div>
    </vs-prompt>

    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter justify-center items-center">
            <div class="vx-col hidden lg:block lg:w-1/2 p-4">
              <img src="@/assets/images/pages/graphic-4.png" alt="login" class="mx-auto" width="60%" />
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8 login-tabs-container">
                <div class="vx-card__title mb-4">
                  <h3 class="mb-4"> <strong>Login </strong>
                    <span style="font-size: 10px">v2.2</span></h3>
                  <p>Welcome back, please login to your account.</p>
                </div>

                <div>
                  <vs-input
                    name="email"
                    icon-no-border
                    icon="icon icon-user"
                    icon-pack="feather"
                    label-placeholder="Email"
                    v-model="email"
                    class="w-full"
                    @keyup.enter="loginUser"
                  />

                  <vs-input
                    type="password"
                    name="password"
                    icon-no-border
                    icon="icon icon-lock"
                    icon-pack="feather"
                    label-placeholder="Password"
                    v-model="password"
                    class="w-full mt-6"
                    @keyup.enter="loginUser"
                  />
                  <div class="flex flex-wrap justify-between my-5">
                    <span
                      style="color: blue; cursor: pointer"
                      @click="showForgotPassword = true"
                      >Forgot Password?</span
                    >
                  </div>
                  <vs-button
                    class="float-right mt-5 mb-5"
                    @click="loginUser"
                    :disabled="!validateForm"
                    >Login</vs-button
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import axios from "@/axios.js";
import { alertMixin } from "../../mixin/alertMixin";
import { helperMixin } from "../../mixin/helperMixin";
import { axiosMixin } from "../../mixin/axiosMixin";
import VueQRCodeComponent from 'vue-qrcode-component'
export default {
  mixins: [alertMixin, helperMixin, axiosMixin],
  data() {
    return {
      email: "",
      password: "",
      showForgotPassword: false,
      checkbox_remember_me: false,
      emailRecovery: "",
      recoveryEndpoint: "/sendPasswordRecovery",
      getLogoUrl: "@/assets/images/pages/graphic-4.png",
    };
  },
  components:{
    VueQRCodeComponent
  },
  computed: {
    validateForm() {
      return this.email != "" && this.password != "";
    },
    getLogo() {
      axios({
        method: "get",
        url: "getLogo",
      })
        .then((response) => {
          console.log("response:", response["data"]);
          this.getLogoUrl = response["data"];
        })
        .catch((error) => {
          this.decodeErrorFromAxios(error);
        });
    },
  },
  methods: {
    validateEmail() {
      if (this.emailRecovery == "") {
        this.errorAlert("Required", "Your Email Address is required");
        this.showForgotPassword = true;
      } else {
        this.submitPasswordRecovery();
      }
    },
    submitPasswordRecovery() {
      axios({
        method: "post",
        url: this.recoveryEndpoint,
        data: { email: this.emailRecovery },
      })
        .then((response) => {
          if (response.data.status == "success") {
            this.successAlert("Sent", response.data.msg);
          } else {
            this.errorAlert("Failed", response.data.msg);
          }
        })
        .catch((error) => {
          this.decodeErrorFromAxios(error);
        });
    },
    registerUser() {
      this.$router.push("/register").catch(() => {});
    },
    loginUser() {
      const payload = {
        email: this.email,
        password: this.password,
      };

      axios({
        method: "post",
        url: "/loginUser",
        data: payload,
      })
        .then((response) => {
          this.decodeSuccessFromAxios(response);

          this.$store.dispatch("auth/updateToken", response.data.token);
          this.$store.dispatch(
            "auth/updatePermission",
            response.data.permissions
          );

          response.data.data.data.role = this.flattenJsonStringArray(
            response.data.data.data.role,
            "label"
          );
          this.$store.dispatch("auth/updateUserInfo", response.data.data);

          console.log("response.data.settings:", response.data.settings);
          //update the settings
          this.$store.dispatch(
            "auth/updateSystemSettings",
            response.data.settings
          );

          console.log("userinfo:", response.data.data.data);
          this.$router.push("/").catch(() => {});
          //getSelectedOnLevelObj
          if (this.stringContain(response.data.data.data.role, "admin")) {
            this.$router.push("/dashboard/adminDashboard").catch(() => {});
          } else if (
            this.stringContain(response.data.data.data.role, "Client")
          ) {
            this.$router.push("/dashboard/clientDB").catch(() => {});
          }
          //   this.stringContain(response.data.data.data.role, "admin")
          // ) {
          //   this.$router.push("/settings").catch(() => {});
          // } else if (
          //   this.stringContain(response.data.data.data.role, "vendor")
          // ) {
          //   this.$router.push("/dashboard/vendor").catch(() => {});
          // } else if (
          //   this.stringContain(response.data.data.data.role, "Procurement Team")
          // ) {
          //   this.$router.push("/dashboard/procurement").catch(() => {});
          // } else if (
          //   this.stringContain(response.data.data.data.role, "Finance Manager")
          // ) {
          //   this.$router.push("/form/PO/PO Pending Approval").catch(() => {});
          // } else if (this.stringContain(response.data.data.data.role, "MD")) {
          //   this.$router.push("/form/PO/submittedToMD").catch(() => {});
          // } else {
          //   this.$router.push("/dashboard/branchUser").catch(() => {});
          // }
        })
        .catch((error) => {
          this.decodeErrorFromAxios(error);
        });
    },
  },
  mounted() {
    this.getLogo;
  },
};
</script>

<style lang="scss">
#page-login {
  .social-login-buttons {
    .bg-facebook {
      background-color: #1551b1;
    }
    .bg-twitter {
      background-color: #00aaff;
    }
    .bg-google {
      background-color:
